import { ArrayOptionsMapRes } from "system/helpers/types";
import {
  CustomerDataType,
  MerchantDataType,
  PaymentMethodDataType,
} from "modules/transactions/types";

export type UseModuleDataRes = {
  methodsOptions: ArrayOptionsMapRes;
};

export type PaymentItemType = {
  commission: number;
  createdDate: string;
  enabled: boolean;
  id: number;
  maskSensitiveData: boolean;
  redirectEnabled: boolean;
  type: string;
  updatedDate: string;
  merchant: MerchantDataType;
  paymentMethod: PaymentMethodDataType;
};

export type PaymentsDataType = {
  content: PaymentItemType[];
  totalPages: number;
  totalElements: number;
};
export type PaymentDetailsActionLogDataType = {
  changedValue: string;
  createdDate: string;
  id: number;
  key: string;
  merchantPaymentMethodId: number;
  userEmail: string;
}[];

export type PaymentDetailsDataType = {
  id?: number | null;
  createDate: string;
  createdDate: string;
  enabled: boolean;
  key: string;
  merchantPaymentMethodId: number;
  updatedDate: string;
  value: string | null;
}[];

export enum PaymentType {
  DEPOSIT = "DEPOSITS",
  WITHDRAWAL = "WITHDRAWALS",
}


export type PaymentOption = {
  label: string;
  value: PaymentType;
};
